module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('YesNo', {
    staticClass: "mb-4",
    attrs: {
      "label": _vm.schema.label,
      "question": _vm.schema.question,
      "color": "blue",
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.$emit('change', $event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8790c204"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/forms/controls/YesNoControl.vue
// module id = 2625
// module chunks = 1